import { useState, useEffect, useLayoutEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/uiParts/port/Header';
import TitleBar from '../../components/uiParts/TitleBar';
import MenuIcon from '../../components/uiParts/MenuIcon';
import FolderIcon from '@mui/icons-material/Folder';
import { useAuth } from '../../contexts/AuthContext';
import MonitorIcon from '@mui/icons-material/Monitor';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import PanToolIcon from '@mui/icons-material/PanTool';
import TodayIcon from '@mui/icons-material/Today';

const HomePort = () => {
    
    const navigate = useNavigate();
    
	//===============================================
	// initialize
	//===============================================
	//-----------------------------------------------
    // initialize - セッション情報を取得
	//-----------------------------------------------
    const { authInfo } = useAuth();
    const facilityCode   = authInfo.facilityCode;
    const facilityName   = authInfo.facilityName;
    const userId         = authInfo.userId;
    const userName       = authInfo.userName;
    const lobinAuthority = authInfo.authority;
    const senmeiCode     = authInfo.senmeiCode;
    const today          = authInfo.targetDate;

	//===============================================
	// useEffect
	//===============================================
    //-----------------------------------------------
    // useEffect - ロード時の設定
    //-----------------------------------------------
    useEffect(() => {
    },[]);
    //-----------------------------------------------
    // useLayoutEffect - iPad Safari 初回レンダリング対策
    // 描画前に同期実行されるため、ブラウザは ready=true の状態のみを描画する
    //-----------------------------------------------
    const [ready, setReady] = useState(false);
    useLayoutEffect(() => {
        setReady(true);
    }, []);
    
	//===============================================
	// eventHandler
	//===============================================
	//-----------------------------------------------
    // eventHandler - 日付の変更
	//-----------------------------------------------
    const handleChange_entryDate = (value) => {
    };
	//-----------------------------------------------
    // eventHandler - 画面遷移
	//-----------------------------------------------
    const handleClick = (url) => {
        navigate(url);
    };
	//===============================================
	// JSXのレンダー
	//===============================================
    if (!ready) return null;
    return (
        <>
        <Header loginInfo="on" backButton="off" backPage="/" setEntryDate={handleChange_entryDate} />
            <div className='menu' style={{paddingTop:'2px', paddingLeft:'10px', paddingRight:'10px', paddingBottom:'10px'}}>
                <div>
                    <TitleBar title="入出船メニュー" color="#006400" />
                    <MenuIcon header="Port Menu" title="スケジュール" onClick={() => handleClick('/portSchedule')} color="#006400">
                        <TodayIcon style={{fontSize: '4rem', color: '#006400'}} />
                    </MenuIcon>
                { lobinAuthority != 4 ? 
                    <>
                    {
                    /*
                    <MenuIcon header="Port Menu" title="サイネージ"  onClick={() => handleClick('/scheduleMonitor')} color="#006400">
                        <MonitorIcon style={{fontSize: '4rem', color: '#006400'}} />
                    </MenuIcon>
                    */
                    }
                    <MenuIcon header="Port Menu" title="電子入札へ"  onClick={() => handleClick('/home')} color="#006400">
                        <ShoppingCartIcon style={{fontSize: '4rem', color: '#006400'}} />
                    </MenuIcon>
                    <MenuIcon header="Port Menu" title="衛生管理へ"  onClick={() => handleClick('/hygieneHome')} color="#006400">
                        <PanToolIcon style={{fontSize: '4rem', color: '#006400'}} />
                    </MenuIcon>
                    </>
                : <></>
                }
                </div>
                { lobinAuthority == 1 ? 
                <div>
                    {/*
                    <TitleBar title="管理メニュー" color="#006400" />
                    <MenuIcon header="Management Menu" title="入船管理マスタ"  onClick={() => handleClick('/portMastaMenu')} color="#006400">
                        <FolderIcon style={{fontSize: '4rem', color: '#006400'}} />
                    </MenuIcon>
                     */}
                </div>
                : <></>
                }
            </div>
        </>
    )
}
export default HomePort;